import _extends from "@babel/runtime/helpers/esm/extends";
var HTML_FONT_SIZE = 16;
var rubikFontFamily = "'Rubik', sans-serif";
var nunitoFontFamily = "'Nunito', sans-serif";
export var fontWeight = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700
};
export var fontSize = {
  h1: 30,
  h2: 24,
  h3: 18,
  h4: 16,
  h5: 14,
  h7: 12,
  h8: 10
};
export var fontStyle = {
  normal: 'normal',
  italic: 'italic'
};

var pxToRem = function pxToRem(size) {
  return "".concat(size / HTML_FONT_SIZE, "rem");
};

var buildVariant = function buildVariant(weight, size, lineHeight, letterSpacing, fontFamily) {
  return {
    fontFamily: fontFamily,
    fontWeight: weight,
    fontSize: pxToRem(size),
    letterSpacing: letterSpacing,
    lineHeight: lineHeight
  };
};

var variants = {
  h1: buildVariant(fontWeight.medium, fontSize.h1, 1.13, 'normal', rubikFontFamily),
  h2: buildVariant(fontWeight.medium, fontSize.h2, 1.25, 'normal', rubikFontFamily),
  h3: buildVariant(fontWeight.bold, fontSize.h3, 1.11, 'normal', nunitoFontFamily),
  h4: buildVariant(fontWeight.regular, fontSize.h4, 1.25, 'normal', nunitoFontFamily),
  h5: buildVariant(fontWeight.regular, fontSize.h5, 1.29, 'normal', nunitoFontFamily),
  h6: buildVariant(fontWeight.semiBold, fontSize.h5, 1.29, 'normal', nunitoFontFamily),
  h7: buildVariant(fontWeight.regular, fontSize.h7, 1.5, 'normal', nunitoFontFamily),
  h8: buildVariant(fontWeight.regular, fontSize.h8, 1.5, 'normal', rubikFontFamily),
  // deprecated
  running: buildVariant(fontWeight.regular, fontSize.h5, 1.43, 'normal', nunitoFontFamily),
  // deprecated
  secondary: buildVariant(fontWeight.regular, fontSize.h5, 1.29, -0.22, nunitoFontFamily)
};
export default _extends({
  htmlFontSize: HTML_FONT_SIZE
}, variants, {
  fontWeight: fontWeight,
  fontSize: fontSize,
  fontStyle: fontStyle
});